(function(){
'use strict';
var KEY='__PP_REWARDS_CART_V4';
if(window[KEY]){window[KEY].refresh();return;}
var SUIT_ID=15472216309984,eligible={15472216309984:true,15472267526368:true,15472312221920:true,15472404267232:true,15472411443424:true},previous=null,previewPrevious=null,busy=false,pending=false,refreshTimer=null,lastTick=0,cartUnits=0,lastCart=null;
function eligibleID(id){return !!eligible[asNumber(id)];}
function promoTagged(item){return !!(item.properties&&item.properties._pp_promo_hat);}
var base=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
var url=base.replace(/\/?$/,'/')+'cart.js';
function asNumber(x){var v=Number(x);return Number.isFinite(v)?Math.max(0,Math.trunc(v)):0;}
function goalWidth(count){return count>=2?62:count===1?12:0;}
function productQuantity(){
  var productRoot=document.querySelector('product-info')||document.querySelector('.product__info-wrapper');
  if(!productRoot)return 1;
  var field=productRoot.querySelector('.quantity__input, quantity-input input[name="quantity"], input[id^="Quantity-"]');
  return field?Math.max(1,asNumber(field.value)):1;
}
function playBurst(el){
  var host=el.querySelector('[data-pp-burst]');if(!host)return;
  host.innerHTML='';
  var colors=['#FFB633','#F47B20','#1EA77A','#175AA0','#FF6F61','#FFD942'];
  for(var i=0;i<14;i++){
    var bit=document.createElement('i'),angle=(Math.PI*2*i/14),dist=60+(i%4)*15;
    bit.style.setProperty('--burst-x',Math.round(Math.cos(angle)*dist)+'px');
    bit.style.setProperty('--burst-y',Math.round(Math.sin(angle)*dist)+'px');
    bit.style.setProperty('--burst-rot',(90+i*39)+'deg');
    bit.style.setProperty('--burst-delay',((i%4)*.025)+'s');
    bit.style.setProperty('--burst-color',colors[i%colors.length]);
    host.appendChild(bit);
  }
  el.classList.remove('is-celebrating');void el.offsetWidth;el.classList.add('is-celebrating');
  setTimeout(function(){el.classList.remove('is-celebrating');host.innerHTML='';},1350);
}
function draw(units,cart){
  units=asNumber(units);
  if(cart)lastCart=cart;
  var first=previous===null;
  var crossed=previous!==null&&previous<2&&units>=2;
  previous=units;cartUnits=units;
  var subtotal=lastCart?asNumber(lastCart.total_price):0;
  var shippingUnlocked=subtotal>=4499000;
  var suits=0;
  (lastCart&&lastCart.items||[]).forEach(function(item){if(asNumber(item.product_id)===SUIT_ID && !promoTagged(item))suits+=asNumber(item.quantity);});
  var pesos=function(n){return '$'+new Intl.NumberFormat('es-CL').format(Math.round(n));};
  document.querySelectorAll('[data-pp-rewards-v4]').forEach(function(el){
    var inCart=el.getAttribute('data-pp-context')==='cart';
    if(inCart&&units===0){el.hidden=true;return;}
    el.hidden=false;
    var pageId=asNumber(el.getAttribute('data-pp-current-product-id'));
    var eligiblePage=eligibleID(pageId);
    var pendingQty=!inCart&&eligiblePage?productQuantity():0;
    var preview=!inCart&&pendingQty>0;
    var shown=units+pendingQty;
    var displayed=Math.max(units,shown);
    var suitPreview=suits+(!inCart&&pageId===SUIT_ID?pendingQty:0);
    var msg=el.querySelector('[data-pp-message]');
    if(msg){
      if(units>=2){
        msg.textContent=shippingUnlocked?'🎉 ¡Gorrito especial desbloqueado y envío gratis en Chile!':'🎉 ¡Gorrito especial desbloqueado! El envío gratis se activa desde $44.990.';
      }else if(shown>=2){
        msg.textContent='✨ ¡Con esta selección puedes desbloquear el gorrito! Agrégala al carrito.';
      }else if(units===1){
        msg.textContent='¡Falta 1 producto participante para desbloquear el gorrito!';
      }else msg.textContent='Combina 2 productos de la tienda, excepto el collar, para desbloquear el gorrito.';
    }
    el.classList.toggle('is-win',units>=2);
    var count=el.querySelector('[data-pp-count]');if(count)count.textContent=String(units);
    var bar=el.querySelector('.pp-rw__progress');if(bar)bar.setAttribute('aria-valuenow',String(Math.min(displayed,2)));
    var fill=el.querySelector('[data-pp-fill]');
    if(fill){var target=goalWidth(displayed);if(first){fill.style.width='0%';requestAnimationFrame(function(){requestAnimationFrame(function(){fill.style.width=target+'%';});});}else fill.style.width=target+'%';}
    el.querySelectorAll('[data-pp-goal]').forEach(function(n){var level=Number(n.getAttribute('data-pp-goal'));n.classList.toggle('is-reached',level<3&&displayed>=level);});
    var hat=el.querySelector('[data-pp-tier="hat"]');if(hat)hat.classList.toggle('is-unlocked',units>=2);
    var hatStatus=el.querySelector('[data-pp-tier-status="hat"]');if(hatStatus)hatStatus.textContent=units>=2?'✓ ELEGIR':'CON 2';
    var shipping=el.querySelector('[data-pp-tier="shipping"]');if(shipping)shipping.classList.toggle('is-unlocked',shippingUnlocked);
    var shippingStatus=el.querySelector('[data-pp-tier-status="shipping"]');
    if(shippingStatus){shippingStatus.textContent=shippingUnlocked?'✓ ACTIVADO':(subtotal>0?'FALTAN '+pesos(Math.max(0,Math.ceil((4499000-subtotal)/100))):'DESDE $44.990');}
    var second=el.querySelector('[data-pp-second-offer]');
    if(second){
      second.hidden=suitPreview===0;
      second.classList.toggle('is-unlocked',suits>=2);
      var st=second.querySelector('[data-pp-second-title]'),sd=second.querySelector('[data-pp-second-desc]'),ss=second.querySelector('[data-pp-second-status]');
      var priceTiers={2:[44990,4990],3:[62990,11980],4:[79990,19970]};
      var suitTier=priceTiers[Math.min(suits,4)],previewTier=priceTiers[Math.min(suitPreview,4)];
      if(suitTier){
        if(st)st.textContent=suits+' duendes · '+(suitTier?pesos(suitTier[0]):'');
        if(sd)sd.textContent='Descuento especial de '+pesos(suitTier[1])+' según la cantidad de duendes';
        if(ss)ss.textContent='✓ PACK';
      }else if(previewTier){
        if(st)st.textContent=suitPreview+' duendes por '+pesos(previewTier[0]);
        if(sd)sd.textContent='Al agregarlos al carrito · ahorro de '+pesos(previewTier[1]);
        if(ss)ss.textContent='AL AGREGAR';
      }else{
        if(st)st.textContent='2 disfraces de duende por $44.990';
        if(sd)sd.textContent='Ahorra $4.990 comprando 2 disfraces de duende';
        if(ss)ss.textContent='PACK DUENDE';
      }
    }
    var deal=el.querySelector('[data-pp-deal-total]'),desc=el.querySelector('[data-pp-deal-save]');
    if(deal&&desc){
      var dp={2:[44990,4990],3:[62990,11980],4:[79990,19970]};
      var tier=dp[Math.min(suits,4)],previewTier=dp[Math.min(suitPreview,4)];
      if(tier){deal.textContent=suits+' duendes · '+pesos(tier[0]);desc.textContent='Ahorras '+pesos(tier[1])+' en el pack de duendes';}
      else if(previewTier){deal.textContent=suitPreview+' duendes por '+pesos(previewTier[0]);desc.textContent='Oferta del pack al agregarlos al carrito';}
      else if(units>=2){deal.textContent='¡Gorrito especial desbloqueado!';desc.textContent=shippingUnlocked?'También tienes envío gratis en Chile':'Envío gratis en Chile desde $44.990';}
      else {deal.textContent='Lleva 2 productos y elige tu gorrito';desc.textContent='Participan 5 productos · Excluye el collar';}
    }
    if(crossed&&units>=2)playBurst(el);
  });
  previewPrevious=productQuantity();
}
async function refresh(){
  if(busy){pending=true;return;}
  busy=true;lastTick=Date.now();
  try{
    var res=await fetch(url,{method:'GET',credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
    if(!res.ok)throw Error('Shopify cart '+res.status);
    var cart=await res.json(),num=0;
    (cart.items||[]).forEach(function(item){if(eligibleID(item.product_id)&&!promoTagged(item))num+=asNumber(item.quantity);});
    draw(num,cart); if(window.__PP_HAT_OFFER_V1 && typeof window.__PP_HAT_OFFER_V1.sync === 'function'){window.__PP_HAT_OFFER_V1.sync(cart);}
  }catch(err){document.querySelectorAll('[data-pp-rewards-v4] [data-pp-message]').forEach(function(node){node.textContent='No se pudo leer el carrito. Recarga la página para actualizar.';});}
  finally{busy=false;if(pending){pending=false;schedule(200);}}
}
function preview(){draw(cartUnits);}
function schedule(ms){clearTimeout(refreshTimer);refreshTimer=setTimeout(function(){refreshTimer=null;refresh();},ms||150);}
window[KEY]={refresh:refresh,schedule:schedule};
if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'&&PUB_SUB_EVENTS.cartUpdate){try{subscribe(PUB_SUB_EVENTS.cartUpdate,function(){schedule(110);});}catch(e){}}
document.addEventListener('cart:updated',function(){schedule(100);});
document.addEventListener('cart:refresh',function(){schedule(100);});
document.addEventListener('shopify:section:load',function(){schedule(110);});
document.addEventListener('input',function(e){if(e.target.matches('.quantity__input, input[id^="Quantity-"]'))preview();},true);
document.addEventListener('change',function(e){
  if(e.target.matches('.quantity__input, input[id^="Quantity-"]'))preview();
  if(e.target.closest('cart-drawer')||e.target.closest('cart-items'))schedule(400);
},true);
document.addEventListener('click',function(e){
  if(e.target.closest('.quantity__button, quantity-input button')){setTimeout(preview,70);}
  if(e.target.closest('cart-drawer button, cart-drawer a[href*="/cart/change"], .product-form__submit, button[name="add"], .cart-remove-button')){schedule(650);}
},true);
window.addEventListener('pageshow',function(){schedule(50);});
document.addEventListener('visibilitychange',function(){if(!document.hidden)schedule(70);});
var observer=new MutationObserver(function(changes){
  var relevant=changes.some(function(m){var e=m.target.nodeType===1?m.target:m.target.parentElement;return !(e&&e.closest&&e.closest('[data-pp-rewards-v4]'));});
  if(relevant&&Date.now()-lastTick>270)schedule(150);
});
function observeDrawer(){var el=document.querySelector('cart-drawer');if(el&&el!==window.__ppRewardDrawer){observer.disconnect();observer.observe(el,{childList:true,subtree:true});window.__ppRewardDrawer=el;}}
observeDrawer();
var outer=new MutationObserver(function(m){if(m.some(function(x){return Array.from(x.addedNodes).some(function(n){return n.nodeType===1&&(n.matches&&n.matches('cart-drawer')||n.querySelector&&n.querySelector('cart-drawer'));});})){observeDrawer();schedule(150);}});
outer.observe(document.body,{childList:true,subtree:false});
setInterval(function(){if(document.hidden)return;var d=document.querySelector('cart-drawer');if(d&&(d.classList.contains('active')||d.hasAttribute('open'))&&Date.now()-lastTick>2500)refresh();},3000);
refresh();
})();